export default (property = 'name', direction = 'asc') => (a, b) => {
  const aLower = a[property].toLowerCase()
  const bLower = b[property].toLowerCase()

  if (aLower > bLower) return direction === 'asc' ? 1 : -1
  if (aLower < bLower) return direction === 'asc' ? -1 : 1
  return 0
}
